const RANKING_ITEMS = [
  { rank: 1, title: '我独自升级', type: '韩漫', hot: '9.9', change: 'up', tag: '热度登顶' },
  { rank: 2, title: '剑尊归来', type: '韩漫', hot: '9.8', change: 'up', tag: '本周飙升' },
  { rank: 3, title: '全职高手', type: '国漫', hot: '9.7', change: 'same', tag: '稳定发力' },
  { rank: 4, title: '暗黑法则', type: '韩漫', hot: '9.5', change: 'up', tag: '口碑新贵' },
  { rank: 5, title: '樱花下的约定', type: '日漫', hot: '9.4', change: 'down', tag: '完结神作' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            人气排行
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            实时热度排行榜，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
            {RANKING_ITEMS.map((item, i) => (
              <div
                key={i}
                className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100/60 transition-colors cursor-pointer ${
                  i < RANKING_ITEMS.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-primary-400 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-400 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="text-sm font-heading font-bold text-foreground-900">{item.title}</h3>
                    <span className="text-xs px-1.5 py-0.5 rounded bg-background-200 text-foreground-500 whitespace-nowrap">
                      {item.type}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  <div className="flex items-center gap-1">
                    <span className="text-sm font-bold text-primary-600">{item.hot}</span>
                    <span className={`w-4 h-4 flex items-center justify-center ${
                      item.change === 'up' ? 'text-primary-500' : item.change === 'down' ? 'text-foreground-400' : 'text-foreground-400'
                    }`}>
                      <i className={`text-xs ${item.change === 'up' ? 'ri-arrow-up-fill' : item.change === 'down' ? 'ri-arrow-down-fill' : 'ri-subtract-line'}`}></i>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}